import { Injectable } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class AppAuthService {
    logout(reload?: boolean, returnUrl?: string): void {
        abp.auth.clearToken();
        if (reload !== false) {
            if (returnUrl) {
                location.href = returnUrl;
            } else {
                location.href = AppConsts.logoutUrl;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/auth/app-auth.service.ts